import React, { useContext } from "react";
import themeContext from "../../context/theme/ThemeContext";

const Attention = ({ color }) => {
  const { getAlterColor } = useContext(themeContext);
  return (
    <svg
     width="18"
     height="18" 
     fill="none" 
     viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg">
        <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z" 
        fill={color || getAlterColor("#FFE144","rgb(201 192 30)")}
        />

      {/* <path d="M12 2c5.523 0 10 4.478 10 10s-4.477 10-10 10S2 17.522 2 12 6.477 2 12 2Zm.002 13.004a.999.999 0 1 0 0 1.997.999.999 0 0 0 0-1.997ZM12 7a1 1 0 0 0-.993.884L11 8l.002 5.001.007.117a1 1 0 0 0 1.986 0l.007-.117L13 8l-.007-.117A1 1 0 0 0 12 7Z" 
       fill={getAlterColor("#FFE144","rgb(201 192 30)")}
       /> */}
    </svg>
  
  );
};

export default Attention;

